import { Box, Skeleton } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router-dom';

import { CreditFacilityBankAccountsContainer } from './CreditFacilityAccountsContainer';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { useUserAuthOrThrow } from '~/contexts/UserAuthProvider';
import { SettingsViewTemplate } from '~/core/routes/settings/SettingsTemplate';
import { PageHeader } from '~/packages/common-frontend/components/PageContainer';
import { useGetCreditFacilitiesQuery } from '~/packages/credit-facility/requests/requests.gql.generated';

// Fragments
const RouteBase = () => {
  const { user } = useUserAuthOrThrow();

  const creditFacilitiesQuery = useGetCreditFacilitiesQuery({
    variables: { organizationId: user.organizationId },
  });

  if (
    creditFacilitiesQuery.loading ||
    !creditFacilitiesQuery.data ||
    !creditFacilitiesQuery.data?.creditFacilities
  ) {
    return <Skeleton data-testid="loading-bank-accounts" height="600px" />;
  }

  if (creditFacilitiesQuery.error) throw creditFacilitiesQuery.error;

  if (creditFacilitiesQuery.data.creditFacilities.length === 0) {
    throw Error(
      `Borrower ${user.organization.slug} should have at least one existing credit facility`,
    );
  }

  return (
    <Box>
      <PageHeader headerLabel="Bank accounts" marginBottom="30px" />
      {creditFacilitiesQuery.data.creditFacilities.map(
        (creditFacility, idx) => {
          return (
            <CreditFacilityBankAccountsContainer
              borrowerId={user.organizationId}
              creditFacilityId={creditFacility.id}
              creditFacilitySlug={creditFacility.slug}
              creditFacilityNumber={idx + 1}
              key={creditFacility.id}
            />
          );
        },
      )}
    </Box>
  );
};

// Exports
export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/settings" />;
      }}
    >
      <SettingsViewTemplate>
        <RouteBase />
      </SettingsViewTemplate>
    </RouteErrorBoundary>
  );
};
